import { Entity, JobSource, LeadViewFilters, Lex, LexoRank, OpportunityViewFilters } from '../index';

export enum LeadViewVisibility {
    Private = 'Private',
    Public = 'Public',
    Shared = 'Shared'
}

export enum LeadSystemViewName {
    MyLeads = 'My Leads',
    NewThisWeek = 'New This Week',
    NewLastWeek = 'New Last Week',
    All = 'All Leads'
}

export enum LeadViewDisplayType {
    Kanban = 'Kanban',
    List = 'List'
}

export type LeadViewSortType = 'ASC' | 'DESC';

export enum LeadViewSortBy {
    None = 'none',
    Name = 'name',
    Amount = 'amount',
    CreatedDate = 'createdAt',
    LastActivity = 'sorting.lastActivity',
    // ExpectedCloseDate = 'expectedClose',
}

export interface LeadViewSortOptions {
    sortBy: LeadViewSortBy;
    sortType: LeadViewSortType;
}

export interface LeadViewSummary {
    _id: string;
    name: string;
    visibility: LeadViewVisibility;
    displayType: LeadViewDisplayType;
    sort?: LeadViewSortOptions;
    list: LeadViewListField[];
    isDefault: boolean;
    system: boolean;
    selected: boolean;
    ownerId?: string;
    canEditView?: boolean;
    sharedWith: Entity[]
    filters?: LeadViewFilters;
}

export interface LeadViewListField {
    _id: string;
    name: string;
    visible: boolean;
    sortOrder: Lex;
    system: boolean;
}

export const DefaultLeadFields = [
    { _id: 'name', name: 'Name', visible: true, system: true },
    { _id: 'company', name: 'Company', visible: true, system: true },
    { _id: 'phone', name: 'Phone', visible: true, system: true },
    { _id: 'email', name: 'Email', visible: true, system: true },
    { _id: 'contact', name: 'Contact', visible: true, system: true },
    { _id: 'address', name: 'Address', visible: true, system: true },
    { _id: 'owner', name: 'Owner', visible: true, system: true },
    { _id: 'source', name: 'Source', visible: true, system: true },
    { _id: 'jobType', name: 'Job Type', visible: true, system: true },
    { _id: 'tags', name: 'Tags', visible: true, system: true },
    { _id: 'stage', name: 'Stage', visible: true, system: true },
] as LeadViewListField[];

export interface LeadView extends Entity {

    description: string;
    displayType?: LeadViewDisplayType;
    visibility?: LeadViewVisibility;
    sharedWith?: Entity[];

    owner: Entity;
    system?: boolean;

    filters: LeadViewFilters;
    list: LeadViewListField[];

    canEditView?: boolean;
    canShareView?: boolean;

}


export function emptyLeadView(data?: Partial<LeadView>) {
    return {
        name: null,
        description: null,
        displayType: LeadViewDisplayType.List,
        visibility: LeadViewVisibility.Private,
        sharedWith: [],
        filters: {},
        list: [...DefaultLeadFields],
        ...data,
    } as LeadView;
}